import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Timeline: ComponentStyleConfig = {
  parts: ['Timeline', 'TimelineItem', 'Label', 'Connector', 'Dot', 'Content'],
  baseStyle: () => ({
    Timeline: {
      listStyleType: 'none',
    },
    TimelineItem: {
      position: 'relative',
      pb: 5,
    },
    Label: {
      position: 'absolute',
      top: -2,
      width: 'calc(50% - 12px)',
    },
    Connector: {
      position: 'absolute',
      top: 2.5,
      height: 'calc(100% - 10px)',
      borderLeft: '2px solid',
    },
    Dot: {
      w: 2.5,
      h: 2.5,
      border: '2px solid',
      borderRadius: '50%',
      position: 'absolute',
    },
    Content: {
      position: 'relative',
      pt: 3,
      wordBreak: 'break-word',
    },
  }),
};

export default Timeline;
